
(function () {
    var minVisitors = 500;
    var lastVisitorData = null;

    function modifyCounter() {
    const elements = document.querySelectorAll('body .visitors_counter');

    if (!lastVisitorData || lastVisitorData.totalvisitor >= minVisitors) {
        return;
    } else {
        elements.forEach(function (element) {
        element.remove();
        });
    }
    }

    document.addEventListener('vcafterload', function (e) {
    lastVisitorData = e.detail.data;
    modifyCounter();
    });

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, modifyCounter);
    }
})();
